module.exports = __webpack_public_path__ + "static/img/m_bg.b9f7095.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/fiveG/m_bg.png
// module id = heH0
// module chunks = 1